export const FETCH_APPS_REQUEST = 'FETCH_APPS_REQUEST';
export const FETCH_APPS_SUCCESS = 'FETCH_APPS_SUCCESS';
export const FETCH_APPS_FAILURE = 'FETCH_APPS_FAILURE';
